import script from "./contacts-table.vue?vue&type=script&setup=true&lang=js"
export * from "./contacts-table.vue?vue&type=script&setup=true&lang=js"

import "./contacts-table.vue?vue&type=style&index=0&id=2be3e9d2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be3e9d2"]])

export default __exports__